'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby/~/react-dom/index.js
 ** module id = 35
 ** module chunks = 0
 **/